import { MANDATE, MISSION_COMMITMENTS } from "@/content/ministry";
import { useParallax } from "@/hooks/useMotion";
import { Button } from "@/components/ui/Button";
import { Container, Eyebrow } from "@/components/ui/Primitives";
import { Reveal } from "@/components/motion/Reveal";

/** The Quality Living Tribe: the mandate as a major brand-story moment. */
export function Tribe() {
  const words = useParallax<HTMLDivElement>(0.22);
  return (
    <section className="tribe" aria-labelledby="tribe-title">
      <div ref={words} className="tribe__ghost" aria-hidden>
        <span>Quality</span>
        <span>Living</span>
      </div>
      <Container>
        <div className="tribe__head">
          <Reveal>
            <Eyebrow index="02">Our mandate</Eyebrow>
          </Reveal>
          <h2 id="tribe-title" className="tribe__title">
            <Reveal as="span" className="tribe__title-line">
              The Quality
            </Reveal>
            <Reveal as="span" className="tribe__title-line tribe__title-line--em" delay={100}>
              Living Tribe
            </Reveal>
          </h2>
          <Reveal delay={180} className="tribe__lead">
            <p className="tribe__mandate">“{MANDATE.statement}.”</p>
            <p>{MANDATE.tribe}</p>
          </Reveal>
        </div>

        <ol className="tribe__commitments" aria-label="We commit to">
          {MISSION_COMMITMENTS.map((c, i) => (
            <Reveal as="li" key={c.verb} delay={i * 90} className="tribe__commit">
              <span className="tribe__num">0{i + 1}</span>
              <span className="tribe__verb">{c.verb}</span>
              <span className="tribe__object">{c.object}</span>
              <span className="tribe__manner">{c.manner}</span>
            </Reveal>
          ))}
        </ol>

        <Reveal className="tribe__cta">
          <Button to="/about/mission" variant="primary" iconRight="arrowRight">
            Learn about our mandate
          </Button>
        </Reveal>
      </Container>
    </section>
  );
}
